"use client";

import { useEffect } from "react";
import { GTMEvents } from "@/lib/GTMEvents";
import { linkGuestSessionIfNeeded } from "@/lib/eventTracker";
import { useAuthStore } from "@/stores/authStore";

// GTM/GA push: fires once per browser session (sessionStorage-guarded),
// regardless of auth state. GTMManager.pushEvent() forwards this same push to
// the backend (app_opened) from its own leg, so no direct trackBackendEvent
// call is made here — a second call would duplicate the event.
const APP_OPEN_SESSION_KEY = "mila_app_open_tracked";

export default function AppOpenTracker() {
    const token = useAuthStore((state) => state.token);
    const isHydrated = useAuthStore((state) => state.isHydrated);

    // One GTM push per browser session, independent of auth. The backend copy
    // of this event is delivered by GTMManager's backend leg; eventTracker's
    // pre-hydration buffer tags it guest/user once auth settles.
    useEffect(() => {
        if (typeof window === "undefined") return;
        if (sessionStorage.getItem(APP_OPEN_SESSION_KEY)) return;

        sessionStorage.setItem(APP_OPEN_SESSION_KEY, "1");
        GTMEvents.customEvent("app_open", { platform: "web" });
    }, []);

    // Login linking only: linkGuestSessionIfNeeded is idempotent and safe to
    // call on every token change (it no-ops once there's no stored guest
    // session left to link).
    useEffect(() => {
        if (typeof window === "undefined") return;
        if (!isHydrated) return;

        if (token) {
            linkGuestSessionIfNeeded(token);
        }
    }, [token, isHydrated]);

    return null;
}
